var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentRefund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EDF7FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16858_381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71137 12.6941C6.83726 13.6541 7.2221 14.5617 7.8246 15.3196C8.4271 16.0774 9.22454 16.657 10.1314 16.9961C11.0383 17.3352 12.0203 17.4211 12.9723 17.2445C13.9242 17.0679 14.8101 16.6355 15.535 15.9937C16.2599 15.3518 16.7964 14.5248 17.0869 13.6012C17.3775 12.6776 17.4112 11.6924 17.1843 10.7512C16.9575 9.80992 16.4787 8.94818 15.7994 8.25835C15.12 7.56852 14.2657 7.07663 13.328 6.83544C10.7287 6.16878 8.03804 7.50678 7.04471 10.0001",
    stroke: "#2674EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.6665V9.99984H10",
    stroke: "#2674EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16858_381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRefund);
export default __webpack_public_path__ + "static/media/payment_refund.e5beef054ebf561aa25134a29b94bd4e.svg";
export { ForwardRef as ReactComponent };